module.exports = __webpack_public_path__ + "img/down.e88ac03e.svg";